import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { useMainAppContext } from '../../../hooks/useMainAppContext'
import { DoAvatar } from '@dogoo/do-avatar'

const { Option } = Select

const UserSelectLabel = ({ item, className }) => {
    return (
        <div className={className}>
            {item?.screenName ? (
                item?.name
            ) : (
                <span
                    style={{
                        textDecoration: 'line-through'
                    }}
                >
                    {item?.name}
                </span>
            )}
            {item?.screenName && (
                <span className={'text-[#98A2B3]'}> @{item?.screenName}</span>
            )}
        </div>
    )
}

const SelectEmployeeOption = (props) => {
    const { data, placeholder, notFoundContent } = props
    const { allUserInformation } = useMainAppContext()

    const { t } = useTranslation()
    function getData(dataSource) {
        return dataSource?.map((item) => {
            return (
                <Option
                    key={item?.id}
                    value={item?.id}
                    label={<UserSelectLabel item={item} />}
                    // disabled={!item?.screenName}
                >
                    <div className={'flex items-center my-[5px]'}>
                        <DoAvatar
                            ids={[item?.id]}
                            data={allUserInformation}
                        />
                        <div className={'ml-[16px]'}>
                            <UserSelectLabel
                                item={item}
                                className={'font-bold'}
                            />
                            <p className={'text-[#98A2B3] text-[14px]'}>
                                {item?.departmentNameEmployee}
                            </p>
                        </div>
                    </div>
                </Option>
            )
        })
    }

    return (
        <Select
            showSearch={true}
            placeholder={placeholder || t('tnp.components.common.text1')}
            notFoundContent={notFoundContent}
            allowClear={true}
            optionValueProp
            optionLabelProp="label"
            dropdownStyle={{
                padding: '12px'
            }}
            {...props}
        >
            {getData(data)}
        </Select>
    )
}

export default SelectEmployeeOption
